module.exports = __webpack_public_path__ + "img/20190523210458微信截图_20190523210853.d1ba3c64.png";